var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"value":_vm.value,"label":"Buscar...","outlined":"","dense":"","hide-details":""},on:{"input":_vm.search},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('v-icon',[_vm._v("mdi-magnify")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }